import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { IModePillProps, IProvenanceBadgeProps } from 'types/fuelConsumption.interface'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { TipWrap } from './ProvenanceBadge.styled'

const metaOf = (
  provenance: IProvenanceBadgeProps['provenance'],
): { label: string; tone: IStatusPill['status']; tip: string } => {
  if (provenance === 'MEASURED') {
    return {
      label: 'MEASURED',
      tone: 'info',
      tip: 'Measured by fuel level and flow telemetry on the machine.',
    }
  }
  if (provenance === 'BETWEEN_FILLS') {
    return {
      label: 'BETWEEN FILLS',
      tone: 'neutral',
      tip: 'Litres dispensed divided by engine-hours between consecutive fills.',
    }
  }
  return {
    label: 'ATTRIBUTED',
    tone: 'accent',
    tip: 'Window litres split by operating-time share — not measured per person or task.',
  }
}

export const ProvenanceBadge = ({ provenance }: IProvenanceBadgeProps) => {
  const meta = metaOf(provenance)
  return (
    <TipWrap title={meta.tip}>
      <StatusPill status={meta.tone}>{meta.label}</StatusPill>
    </TipWrap>
  )
}

export const ModePill = ({ mode }: IModePillProps) => (
  <TipWrap
    title={
      mode === 'TELEMETRY'
        ? 'Fuel level, flow and engine signals stream from the machine.'
        : 'Burn is only knowable between fills — litres dispensed over SMU hours.'
    }
  >
    <StatusPill status={mode === 'TELEMETRY' ? 'info' : 'neutral'}>{mode}</StatusPill>
  </TipWrap>
)
